var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLtr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 2.79086 2.79086 1 5 1H16V35H5C2.79086 35 1 33.2091 1 31V5Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 1.94444V1H16H15.5V1.94444H16.5ZM16.5 5.72222V3.83333H15.5V5.72222H16.5ZM16.5 9.5V7.61111H15.5V9.5H16.5ZM16.5 13.2778V11.3889H15.5V13.2778H16.5ZM16.5 17.0556V15.1667H15.5V17.0556H16.5ZM16.5 20.8333V18.9444H15.5V20.8333H16.5ZM16.5 24.6111V22.7222H15.5V24.6111H16.5ZM16.5 28.3889V26.5H15.5V28.3889H16.5ZM16.5 32.1667V30.2778H15.5V32.1667H16.5ZM15.5 35V34.0556H16.5V35H16H15.5Z",
    fill: "#2196F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 4,
    stroke: "#2196F3",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtr);
export default __webpack_public_path__ + "static/media/ltr.7808c51fdde2ddd2dd4b750a129882bc.svg";
export { ForwardRef as ReactComponent };